<template>
	<div>
		<!-- Main -->
		<nav class="uk-navbar-container uk-margin-small-bottom" uk-navbar>
			<div class="uk-navbar-left">
				<span class="uk-navbar-item uk-logo">業務マスタ</span>
			</div>
			<div class="uk-navbar-right">
				<div class="navbar-item">
					<button class="uk-button uk-text-small uk-button-small uk-button-default" @click="clickLogoutButton">ログアウト</button>
				</div>
			</div>
		</nav>
		<div class="uk-container uk-container-expand uk-margin-medium uk-margin-remove-left uk-margin-remove-right">
			<div class="uk-align-right">
				<button class="uk-button uk-button-primary" @click="showCreateFormDialog">業務追加</button>
				<button class="uk-button uk-button-default" @click="returnButton">戻る</button>
			</div>
		</div>
		<div class="uk-container uk-container-expand uk-margin-medium uk-margin-remove-left uk-margin-remove-right">
			<table id="job_type_table" class="uk-table uk-table-expand uk-table-striped">
				<thead>
				<tr>
					<th>NO.</th>
					<th>業務名</th>
					<th>業務コード</th>
					<th>有効<br><span style="color: #b9e0d9">※一括選択できます</span><br><input id="bulk_check_action" class="uk-checkbox" type="checkbox" @click="bulkCheckAction"></th>
					<th>空き枠</th>
					<th>更新日</th>
					<th>編集</th>
				</tr>
				</thead>
				<tbody>
				<template v-for="(job_type, index) in job_types">
					<tr class="data_row" :key="index" :data-id="job_type.id">
						<td>{{ job_type.id }}</td>
						<td>{{ job_type.name }}</td>
						<td>{{ job_type.code }}</td>
						<template v-if="job_type.status == 0">
							<td><input class="uk-checkbox" name="status" type="checkbox" checked></td>
						</template>
						<template v-else>
							<td><input class="uk-checkbox" name="status" type="checkbox"></td>
						</template>

						<!-- 空き枠 -->
						<template v-if="job_type.unoccupied_status == 1">
							<td><input class="uk-checkbox" name="unoccupied_status" type="checkbox" checked></td>
						</template>
						<template v-else>
							<td><input class="uk-checkbox" name="unoccupied_status" type="checkbox"></td>
						</template>

						<td>{{ job_type.updated_at | moment }}</td>
						<td>
							<button class="uk-button uk-button-default" @click="showEditDialog(job_type.id)">編集</button>
						</td>
					</tr>
				</template>
				<tr>
					<td>
						<button class="uk-button uk-button-default" @click="showCreateFormDialog">+</button>
					</td>
					<td></td>
					<td></td>
					<td></td>
					<td></td>
					<td></td>
					<td></td>
				</tr>
				</tbody>
			</table>
			<div class="uk-container uk-container-expand uk-margin-small-bottom">
				<div class="uk-align-right">
					<button class="uk-button uk-button-primary" @click="saveEditJobType">保存</button>
				</div>
			</div>
		</div>
		<!--/ Main -->
		<!-- CreateFormDialog -->
		<div id="create_form_dialog" uk-modal>
			<div class="uk-modal-dialog uk-modal-body">
				<div class="uk-overflow-hidden">
					<div class="uk-align-left">
						<h2 class="uk-modal-title">追加</h2>
					</div>
					<div class="uk-align-right">
						<button id="create_form_dialog_close" class="uk-icon-button" type="button" uk-icon="close"></button>
					</div>
				</div>
				<form id="create_form">
					<div class="uk-form-horizontal">
						<div class="uk-margin uk-overflow-hidden">
							<label class="uk-form-label" for="create_form_job_type_name">業務名 (必須)</label>
							<div class="uk-form-controls">
								<input id="create_form_job_type_name" class="uk-input" name="name" placeholder="業務名を入力してください">
								<template v-if="typeof this.createFormState.errors.name != undefined">
									<template v-for="(error,index) in this.createFormState.errors.name">
										<p class="uk-alert-danger uk-padding-small" :key="index">{{ error }}</p>
									</template>
								</template>
							</div>
						</div>
						<div class="uk-margin">
							<button class="uk-width-1-1@l uk-button uk-button-large uk-button-primary" type="button" @click="saveCreateForm">追加</button>
						</div>
					</div>
				</form>
			</div>
		</div>
		<!--/ CreateFormDialog -->
		<!-- EditFormDialog -->
		<div id="edit_form_dialog" uk-modal>
			<div class="uk-modal-dialog uk-modal-body">
				<div class="uk-overflow-hidden">
					<div class="uk-align-left">
						<h2 class="uk-modal-title">編集</h2>
					</div>
					<div class="uk-align-right">
						<button id="edit_form_dialog_close" class="uk-icon-button" type="button" uk-icon="close"></button>
					</div>
				</div>
				<form id="edit_form">
					<div class="uk-form-horizontal">
						<div class="uk-margin uk-overflow-hidden">
							<label class="uk-form-label" for="edit_form_job_type_name">業務名 (必須)</label>
							<div class="uk-form-controls">
								<input id="edit_form_job_type_name" class="uk-input" name="name" placeholder="業務名を入力してください">
								<template v-if="typeof this.createFormState.errors.name != undefined">
									<template v-for="(error,index) in this.createFormState.errors.name">
										<p class="uk-alert-danger uk-padding-small" :key="index">{{ error }}</p>
									</template>
								</template>
							</div>
						</div>
						<div class="uk-margin">
							<button class="uk-width-1-1@l uk-button uk-button-large uk-button-primary" type="button" @click="saveEditForm">保存</button>
						</div>
					</div>
				</form>
			</div>
		</div>
		<!--/ EditFormDialog -->
	</div>
</template>

<script>
	import StaffAuth from '@/api/StaffAuth'
	import JobType from '@/api/JobType'
	import Role from '@/api/Role'
	import MainOfficeAuth from '@/api/MainOfficeAuth'
	import CallCenterAuth from '@/api/CallCenterAuth'
	import BranchOfficeAuth from '@/api/BranchOfficeAuth'

	export default {
		name: 'MainOfficeJobTypeMasterPage',
		comments: [],
		data () {
			return {
				need_confirm_alert: false,
				job_types: [],
				createFormState: {
					errors: []
				}
			}
		},
		filters: {
			moment: function (date) {
				return moment(date).format('YYYY/MM/DD HH:mm')
			}
		},
		methods: {
			showEditDialog: function (id) {
				this.createFormState.errors = []
				$('#edit_form_dialog').data('id', id)

				let params = new URLSearchParams()
				params.append('id', id)

				JobType.one(params).then(function (response) {
					let data = response.data.data

					$('#edit_form_job_type_name').val(data.name)

					UIkit.modal($('#edit_form_dialog'), {container: '#app div', bgClose: false}).show()
				})
			},
			saveEditForm: function () {
				let self = this

				let id = $('#edit_form_dialog').data('id')

				let params = new URLSearchParams()
				params.append('id', id)
				params.append('name', $('#edit_form_job_type_name').val())

				JobType.update(params).then(function (response) {
					alert('保存完了')
					location.reload()
				}).catch(function (error) {
					self.createFormState.errors = error.response.data.errors
				})
			},
			returnButton: function () {
				if ($('.data_row_before_save').length > 0) {
					if (window.confirm('保存されておりませんが、よろしいですか')) {
						this.$router.push('/main_office')
						location.reload()
					}
				} else {
					this.$router.push('/main_office')
					location.reload()
				}
			},
			clickLogoutButton () {
				let self = this

				// StaffAuth.logout().then(function (response) {
					// CallCenterAuth.logout().then(function (response) {
						// BranchOfficeAuth.logout().then(function (responase) {
							MainOfficeAuth.logout().then(function (response) {
								self.$router.push('/main_office/login')
								location.reload()
							})
						// })
					// })
				// })
			},
			bulkCheckAction () {
				let checked = $('#bulk_check_action').prop('checked')
				$('#job_type_table tbody .data_row [name="status"]').prop('checked', checked)
				$('#job_type_table tbody .data_row').addClass('data_row_before_save')
			},
			saveEditJobType () {
				let self = this
				let length = $('#job_type_table .data_row_before_save').length

				$('#job_type_table .data_row_before_save').each(function (i) {
					let index = i

					let id = $(this).data('id')
					let status = 1

					if ($(this).find('[name="status"]').prop('checked')) {
						status = 0
					}

					let unoccupied_status = 0

					if ($(this).find('[name="unoccupied_status"]').prop('checked')) {
						unoccupied_status = 1
					}

					let params = new URLSearchParams()
					params.append('id', id)
					params.append('status', status)
					params.append('unoccupied_status', unoccupied_status)

					JobType.update(params).then(function () {
						if (i + 1 == length) {
							alert('保存完了')
							location.reload()
						}
					})
				})
			},
			loadJobTypes () {
				let self = this

				JobType.all().then(function (response) {
					self.job_types = response.data.data
				})
			},
			saveCreateForm () { // ダイアログ保存
				let self = this

				StaffAuth.current().then(function (response) {
					let staff = response.data.data
					let name = $('#create_form [name="name"]').val()

					let params = new URLSearchParams()
					params.append('name', name)

					JobType.create(params).then(function (response) {
						alert('保存完了')
						location.reload()
					}).catch(function (error) {
						self.createFormState.errors = error.response.data.errors
					})
				})
			},
			showCreateFormDialog () { // ダイアログ表示
				this.createFormState.errors = []
				UIkit.modal($('#create_form_dialog'), {container: '#app div', bgClose: false}).show()
			},
			registerDataChangeEvent () { // データを変更した時のイベント登録
				$(document).on('change', '#job_type_table .data_row .uk-checkbox', function () {
					if ($(this).text() != $(this).data('first')) {
						$(this).closest('.data_row').addClass('data_row_before_save')
					}
				})
			}
		},
		created () {
			this.loadJobTypes()
		},
		beforeMount () {
		},
		mounted () {
			this.registerDataChangeEvent()

			let self = this

			Role.show().then(function (response) { // 権限取得
				let data = response.data

				if (data.data.is_main_office != true) { // 権限が無い場合
					self.$router.push('/')
				}
			})

			$('#create_form_dialog_close').on('click', function () {
				if (self.need_confirm_alert) {
					if (window.confirm('保存されておりませんが、よろしいですか')) {
						UIkit.modal($('#create_form_dialog')).hide()
					}
				} else {
					UIkit.modal($('#create_form_dialog')).hide()
				}

				self.need_confirm_alert = false
			})

			$('#edit_form_dialog_close').on('click', function () {
				if (self.need_confirm_alert) {
					if (window.confirm('保存されておりませんが、よろしいですか')) {
						UIkit.modal($('#edit_form_dialog')).hide()
					}
				} else {
					UIkit.modal($('#edit_form_dialog')).hide()
				}

				self.need_confirm_alert = false
			})

			$('#create_form_dialog').on('change', function () {
				self.need_confirm_alert = true
			})

			$('#edit_form_dialog').on('change', function () {
				self.need_confirm_alert = true
			})
		},
		beforeRouteLeave (to, from, next) {
			$('.uk-open').remove()
			next()
		}
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
	#job_type_table {
		thead {
			tr {
				th {
					border: solid 1px #DDD;
					text-align: center;
					vertical-align: middle;
				}
			}
		}

		tbody {
			tr {
				td {
					border: solid 1px #DDD;
					text-align: center;
					vertical-align: middle;

					&:focus {
						background: #FFF;
					}
				}
			}
		}

		.data_row_before_save {
			background: #FFFDE6;
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/page/MainOfficeJobTypeMasterPage.vue